/* eslint-disable no-restricted-imports */
import {
    DirectPayForType,
    DirectSpendLimitType,
    DirectStrategyType,
} from '../../../../data-layer/direct/types';
import { DropdownOption } from '../../../../ui/business/ContentPromotionBudget/parts/ContentPromotionDropdown/types';

export interface SpendLimitOptionsProps {
    enableWeeklyLimit?: boolean;
    enableCrr?: boolean;
}

export const getSpendLimitOptions = (
    strategyType: DirectStrategyType,
    payFor: DirectPayForType,
    options?: SpendLimitOptionsProps,
): DropdownOption[] => {
    let result: DropdownOption[] = [];

    if (strategyType === DirectStrategyType.MAX_CONVERSIONS && payFor === DirectPayForType.CLICKS) {
        options?.enableWeeklyLimit &&
            result.push({ value: DirectSpendLimitType.WEEKLY_LIMIT, label: 'Бюджет' });
        options?.enableCrr &&
            result.push({ value: DirectSpendLimitType.CRR, label: 'Доля рекламных расходов' });

        result.push({ value: DirectSpendLimitType.AVERAGE_CPA, label: 'Средняя цена конверсии' });

        return result;
    }

    if (
        strategyType === DirectStrategyType.MAX_CONVERSIONS &&
        payFor === DirectPayForType.CONVERSIONS
    ) {
        result = [{ value: DirectSpendLimitType.CONVERSION_COST, label: 'Цена конверсии' }];

        options?.enableCrr &&
            result.push({ value: DirectSpendLimitType.CRR, label: 'Доля рекламных расходов' });

        return result;
    }

    if (strategyType === DirectStrategyType.MAX_CLICKS) {
        result = options?.enableWeeklyLimit
            ? [{ value: DirectSpendLimitType.WEEKLY_LIMIT, label: 'Бюджет' }]
            : [];

        result.push({ value: DirectSpendLimitType.AVERAGE_CPC, label: 'Средняя цена клика' });

        return result;
    }

    return [];
};
